import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df03219"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog__title" }
const _hoisted_2 = { class: "dialog__text" }

import { computed } from "vue";
import { msalInstance } from "@/app.config";
import { useMainStore } from "@/store";
import { useTestStore } from "@/store/UserTestModule";
import { useAuthStore } from "@/store/AuthModule";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  setup(__props) {

const store = useMainStore();
const testStore = useTestStore();
const authStore = useAuthStore();

const confirm = computed(() => {
  return store.modalParameters.state;
});

function closeDialog() {
  store.setModalParameters({
    title: "",
    message: "",
    state: false,
    action: "",
  });
}

function acceptDialog() {
  eval(store.modalParameters.action + "()");
  store.setModalParameters({
    title: "",
    message: "",
    state: false,
    action: "",
  });
}

function goToAdminPage() {
  router.push({ name: "admin" });
}

async function logout() {
  const accounts = await msalInstance.getAllAccounts();
  const logoutRequest = {
    account: accounts[0],
    postLogoutRedirectUri: "/",
  };

  await msalInstance.logoutPopup(logoutRequest).then(() => {
    router.push({ name: "login" });
    authStore.$reset();
    testStore.$reset();
    store.$reset();
  });
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: confirm.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirm).value = $event)),
    class: "dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "dialog__card" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center q-pb-none dialog__card__close-icon" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(store).modalParameters.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row items-center" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(store).modalParameters.message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "dialog__actions" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "base-btn base-btn-yellow",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (acceptDialog()))
              }, " Да "),
              _createElementVNode("button", {
                class: "base-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (closeDialog()))
              }, "Отмена")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})